export function generateDummyId<T extends { id: number | null }>(allItems: T[]): number {
  if (allItems.length === 0) {
    return -1;
  }

  const elementWithLowestId = allItems.reduce(function (prev, curr) {
    return prev.id! < curr.id! ? prev : curr;
  });

  return elementWithLowestId.id! >= 0 ? -1 : elementWithLowestId.id! - 1;
}

export function pairwise<U>(arr, func): U[] {
  const res = Array<U>();
  for (let i = 0; i < arr.length - 1; i++) {
    res.push(func(arr[i], arr[i + 1]));
  }

  return res;
}

export interface ICanBeOrdered {
  order: number;
}
export function insertByOrder<T extends ICanBeOrdered>(arr: T[], newItem: T): number {
  const idx = arr.findIndex((x) => x.order > newItem.order - 1);
  const insertAt = idx === -1 ? arr.length : idx;
  arr.splice(insertAt, 0, newItem);
  return insertAt;
}
